import { RenderElementProps } from "slate-react";
import { RT_ParagraphElement } from "../../types";
import styled from "styled-components";

// ---------------------------------------------------------------------- //

const StyledParagraph = styled("p")`
  color: "#212121";
  font-size: 1.125rem;
  font-weight: 400;
  margin: 0;
`;

// ---------------------------------------------------------------------- //

type ParagraphElementProps = RenderElementProps & {
  element: RT_ParagraphElement;
};

export function ParagraphElement({
  attributes,
  children,
  element,
}: ParagraphElementProps) {
  return (
    <StyledParagraph style={{ textAlign: element.align }} {...attributes}>
      {children}
    </StyledParagraph>
  );
}

// ---------------------------------------------------------------------- //

type ParagraphElementStaticProps = {
  element: RT_ParagraphElement;
  children: React.ReactNode;
};

export function ParagraphElementStatic({
  element,
  children,
}: ParagraphElementStaticProps) {
  return (
    <StyledParagraph style={{ textAlign: element.align }}>
      {children}
    </StyledParagraph>
  );
}
